import React, { useState, useEffect } from "react";
import "../styles/AuditDashboard.css";
import { Line } from "react-chartjs-2";
import { Bar } from "react-chartjs-2";
import { ApiCall } from "./../../utility/ApiCalls";
import Toastify from "toastify-js";
import { ToastContainer, toast } from "react-toastify";
import functionForAgentScore from "./functionForAgentScore";
import Api_Call from "../../ApiCall";

const colorForAgentIfdataNotFound = "#808080";
const stylesForAgentTable = {
  // padding:'12px',
  // fontSize:'8px',
};

const demoDatesForAgent = { startdate: "", enddate: "" };
const demoDatesForError = { startdate: "2023-11-15", enddate: "2024-01-04" };
let recentValidDateAgent = [
  { ...demoDatesForAgent },
  { ...demoDatesForAgent },
  { ...demoDatesForAgent },
];
let recentValidDateError = [
  { ...demoDatesForError },
  { ...demoDatesForError },
  { ...demoDatesForError },
];
// daily  weekly monthly
const LineChart = ({ data, label, className }) => {
  console.log("Line Chart Data:", data);
  const chartData = {
    labels: data.map((item) => item.X),
    datasets: [
      {
        label,
        data: data.map((item) => item.Y),
        fill: false,
        lineTension: 0.1,
        backgroundColor: "rgba(0, 0, 0, 0.1)",
        borderColor: "#FB4E0B",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgba(0, 0, 0, 0.1)",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 2,
        pointHoverRadius: 10,
        pointHoverBackgroundColor: "rgb(255, 99, 132)",
        pointHoverBorderColor: "#FB4E0B",
        pointHoverBorderWidth: 2,
        pointRadius: 5,
        pointHitRadius: 10,
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        min: 0,
        max: 100,
      },
    },
  };
  return (
    <div className={className}>
      <Line data={chartData} options={options} height={280} />
    </div>
  );
};
const BarChart = ({ data, label, className }) => {
  const barColors = data.map((item, index) =>
    index % 2 === 0 ? "#FB4E0B" : "#004EFF"
  );

  const chartData = {
    labels: data.map((item) => item.X),
    datasets: [
      {
        label,
        data: data.map((item) => item.Y),
        backgroundColor: barColors,
        borderColor: "#FB4E0B",
      },
    ],
  };
  const options = {
    responsive: true,
    maintainAspectRatio: false,
  };
  return (
    <div className={className}>
      <Bar data={chartData} options={options} height={280} />
    </div>
  );
};

const ChartComponent = ({ data, label, className }) => {
  // console.log("Chart component Data: ",data);
  const commondata = {
    labels: data.map((item) => item.X),
    datasets: [
      // {
      //     label: 'Line Chart',
      //     fill: false,
      //     lineTension: 0.1,
      //     backgroundColor: 'rgba(75,192,192,0.4)',
      //     borderColor: 'rgba(75,192,192,1)',
      //     borderCapStyle: 'butt',
      //     borderDash: [],
      //     borderDashOffset: 0.0,
      //     borderJoinStyle: 'miter',
      //     pointBorderColor: 'rgba(75,192,192,1)',
      //     pointBackgroundColor: '#fff',
      //     pointBorderWidth: 1,
      //     pointHoverRadius: 5,
      //     pointHoverBackgroundColor: 'rgba(75,192,192,1)',
      //     pointHoverBorderColor: 'rgba(220,220,220,1)',
      //     pointHoverBorderWidth: 2,
      //     pointRadius: 1,
      //     pointHitRadius: 10,
      //     data: [65, 59, 80, 81, 56, 55],
      // },
      {
        label: "cases worked",
        type: "bar",
        // backgroundColor: 'rgba(255,99,132,0.2)',
        // borderColor: 'rgba(255,99,132,1)',
        // borderWidth: 1,
        // hoverBackgroundColor: 'rgba(255,99,132,0.4)',
        // hoverBorderColor: 'rgba(255,99,132,1)',
        // data: [4, 21, 30, 11, 16, 35],

        data: data.map((item) => item.Y1),
        backgroundColor: "#fb4e0b",
        borderColor: "#FB4E0B",
      },
      {
        label: "sample audited",
        type: "bar",
        // backgroundColor: 'rgba(255,99,132,0.2)',
        // borderColor: 'rgba(255,99,132,1)',
        // borderWidth: 1,
        // hoverBackgroundColor: 'rgba(255,99,132,0.4)',
        // hoverBorderColor: 'rgba(255,99,132,1)',
        // data: [4, 21, 30, 11, 16, 35],

        data: data.map((item) => item.Y2),
        backgroundColor: "#004EFF",
        borderColor: "#FB4E0B",
      },
    ],
  };

  return (
    <div className={className}>
      <Line
        data={commondata}
        options={{
          scales: {
            yAxes: [
              {
                ticks: {
                  beginAtZero: true,
                },
              },
            ],
          },
        }}
      />
    </div>
  );
};
function AuditDashboard(data) {
  const [dailyDataname, setdailyDataname] = useState([]);

  // console.log("data in auditDashboard:",data);
  const dailyData = data.data.Quality_Score.daily;

  // console.log("Daily dataa: ",dailyData);
  const weeklyData = data.data.Quality_Score.weekly;
  const monthlyData = data.data.Quality_Score.monthly;

  //const Agent_ScoredailyData = data.data.Agent_Score.daily;
  // const Agent_ScoreweeklyData = data.data.Agent_Score.weekly;
  // const Agent_ScoremonthlyData = data.data.Agent_Score.monthly;

  //console.log("Agent_Score_daily:",Agent_ScoredailyData);
  // console.log("Agent_score_Monthly:",Agent_ScoremonthlyData);

  // const Error_LogdailyData = data.data.Error_Log.daily_count;
  const QA_Total_Volume = data.data.QA_Dashboard.Total_Volume;
  const QA_Completion_Rate = data.data.QA_Dashboard.Completion_Rate;
  const QA_Audit_Timing = data.data.QA_Dashboard.Audit_Timing;
  //const Error_LogweeklyData = data.data.Error_Log.weekly_count;
  //const Error_LogmonthlyData = data.data.Error_Log.monthly_count;

  // console.log("agent score daily data:",Agent_ScoredailyData)

  // const uniqueDates = [...new Set(Error_LogdailyData.flatMap(item => item.Result.map(result => result.Date)))];
  // const Agent_ScoreuniqueDatesdaily = [...new Set(Agent_ScoredailyData.flatMap(item => item.Scores.map(result => result.X)))];
  // const Agent_ScoreuniqueDatesweekly = [...new Set(Agent_ScoreweeklyData.flatMap(item => item.Scores.map(result => result.X)))];
  // const Agent_ScoreuniqueDatesmonthly = [...new Set(Agent_ScoremonthlyData.flatMap(item => item.Scores.map(result => result.X)))];

  //    console.log("Agent_ScoreuniqueDatesmonthy:",Agent_ScoremonthlyData.map(item => item.Scores.map(result => result.X)));

  const [isQualityVisible, setIsQulaityVisible] = useState(false);
  const [isagentVisible, setIsagentVisible] = useState(false);
  const [iserrorVisible, setIserorVisible] = useState(false);
  const [activeCategory, setActiveCategory] = useState(null);
  const [activeSubCategory, setActivesubCategory] = useState(null);
  const [issec0Visible, setissec0Visible] = useState(true);
  const [issec1Visible, setissec1Visible] = useState(false);
  const [issec2Visible, setissec2Visible] = useState(false);
  const [issec3Visible, setissec3Visible] = useState(false);
  const [issec4Visible, setissec4Visible] = useState(false);
  const [issec5Visible, setissec5Visible] = useState(false);
  const [issec6Visible, setissec6Visible] = useState(false);
  const [issec7Visible, setissec7Visible] = useState(false);
  const [issec8Visible, setissec8Visible] = useState(false);
  const [issec9Visible, setissec9Visible] = useState(false);
  const [issec11Visible, setissec11Visible] = useState(false);
  const [issec12Visible, setissec12Visible] = useState(false);
  const [issec10Visible, setissec10Visible] = useState(false);
  const [issec13Visible, setissec13Visible] = useState(false);

  const [isHidden, setIsHidden] = useState(false);

  const [isLeftTabVisible, setIsLeftTabVisible] = useState(true);

  const toggleTaskbar = () => {
    setIsHidden(!isHidden);
    setIsLeftTabVisible(!isLeftTabVisible);
  };

  //console.log("----------16-1-24--------")
  const [dateInDailyDasboard, setDateInDailyDashborad] = useState({
    startdate: "",
    enddate: "",
  });

  const [dateInWeeklyDasboard, setDateInWeeklyDashborad] = useState({
    startdate: "",
    enddate: "",
  });

  const [dateInMonthlyDasboard, setDateInMonthlyDashborad] = useState({
    startdate: "",
    enddate: "",
  });

  const [dataForDailyDashboard, setDataForDailyDashboard] = useState([]);
  const [dataForWeeklyDashboard, setDataForWeeklyDashboard] = useState([]);
  const [dataForMonthlyDashboard, setDataForMonthlyDashboard] = useState([]);

  useEffect(() => {
    getDataForDashboard(
      dateInDailyDasboard.startdate,
      dateInDailyDasboard.enddate,
      "user-daily"
    );
    getDataForDashboard(
      dateInWeeklyDasboard.startdate,
      dateInWeeklyDasboard.enddate,
      "user-weekly"
    );
  }, []);

  //INITIALIZING THE STATES FOR AGENT DASHBOARD
  // const demoDatesForAgent={startdate:"2023-10-20",enddate:"2024-01-19"}
  const [dateInDailyAgentDasboard, setDateInDailyAgentDashborad] = useState({
    startdate: demoDatesForAgent.startdate,
    enddate: demoDatesForAgent.enddate,
  });

  const [dateInWeeklyAgentDasboard, setDateInWeeklyAgentDashborad] = useState({
    startdate: demoDatesForAgent.startdate,
    enddate: demoDatesForAgent.enddate,
  });

  const [dateInMonthlyAgentDasboard, setDateInMonthlyAgentDashborad] = useState(
    {
      startdate: demoDatesForAgent.startdate,
      enddate: demoDatesForAgent.enddate,
    }
  );

  const [dataForDailyAgentDashboard, setDataForDailyAgentDashboard] = useState(
    []
  );
  const [dataForWeeklyAgentDashboard, setDataForWeeklyAgentDashboard] =
    useState([]);
  const [dataForMonthlyAgentDashboard, setDataForMonthlyAgentDashboard] =
    useState([]);

  const [errorDailyAgentDashboard, setErrorDailyAgentDashboard] =
    useState(null);

  const Agent_ScoredailyData = dataForDailyAgentDashboard;
  const Agent_ScoreuniqueDatesdaily = [
    ...new Set(
      Agent_ScoredailyData.flatMap((item) =>
        item.Scores.map((result) => result.X)
      )
    ),
  ];

  const Agent_ScoreweeklyData = dataForWeeklyAgentDashboard;
  const Agent_ScoreuniqueDatesweekly = [
    ...new Set(
      Agent_ScoreweeklyData.flatMap((item) =>
        item.Scores.map((result) => result.X)
      )
    ),
  ];

  const Agent_ScoremonthlyData = dataForMonthlyAgentDashboard;
  const Agent_ScoreuniqueDatesmonthly = [
    ...new Set(
      Agent_ScoremonthlyData.flatMap((item) =>
        item.Scores.map((result) => result.X)
      )
    ),
  ];

  // to represent the demo data 1st time the user load the page in agent
  useEffect(() => {
    const fetchDataForAgentFirstRendering = async () => {
      const dataDaily = await getDataforAgentDashboard(
        dateInDailyAgentDasboard.startdate,
        dateInDailyAgentDasboard.enddate,
        "user_daily"
      );
      const dataWeekly = await getDataforAgentDashboard(
        dateInWeeklyAgentDasboard.startdate,
        dateInWeeklyAgentDasboard.enddate,
        "user_weekly"
      );
      const dataMonthly = await getDataforAgentDashboard(
        dateInMonthlyAgentDasboard.startdate,
        dateInMonthlyAgentDasboard.enddate,
        "user_monthly"
      );

      console.log("----------");
      //console.log("start date and end date:",dateInDailyAgentDasboard.startdate,dateInDailyAgentDasboard.enddate)
      console.log("data from fetchDataForAgentDailyFirstRendering", data);
      console.log("-----------");
      setDataForDailyAgentDashboard(dataDaily);
      setDataForWeeklyAgentDashboard(dataWeekly);
      setDataForMonthlyAgentDashboard(dataMonthly);
    };

    fetchDataForAgentFirstRendering();
    // setDataForDailyAgentDashboard(getDataforAgentDashboard(dateInDailyAgentDasboard.startdate,dateInDailyAgentDasboard.enddate,'user-daily'))
  }, []);
  //    const handleDailyDashboardSearchButton=()=>{
  //     getDataForDashboard(dateInDailyDasboard.startdate,dateInDailyDasboard.enddate,'daily');
  //    }

  //    const handleWeeklyDashboardSearchButton=()=>{
  //     getDataForDashboard(dateInWeeklyDasboard.startdate,dateInWeeklyDasboard.enddate,'weekly');
  //    }

  // const Agent_ScoredailyData = data.data.Agent_Score.daily;
  // const Agent_ScoreweeklyData = data.data.Agent_Score.weekly;
  // const Agent_ScoremonthlyData = data.data.Agent_Score.monthly;

  const [dateInErrorDailyDashboard, setDateInErrorDailyDashboard] = useState({
    startdate: demoDatesForError.startdate,
    enddate: demoDatesForError.enddate,
  });

  const [dateInErrorWeeklyDashboard, setDateInErrorWeeklyDashborad] = useState({
    startdate: demoDatesForError.startdate,
    enddate: demoDatesForError.enddate,
  });

  const [dateInErrorMonthlyDashboard, setDateInErrorMonthlyDashborad] =
    useState({
      startdate: demoDatesForError.startdate,
      enddate: demoDatesForError.enddate,
    });

  const [dataInDailyErrorDashboard, setDataInDailyErrorDashboard] = useState(
    []
  );
  const [dataInWeeklyErrorDashboard, setDataInWeeklyErrorDashboard] = useState(
    []
  );
  const [dataInMonthlyErrorDashboard, setDataInMonthlyErrorDashboard] =
    useState([]);

  const [
    dataInDailyErrorParametersDashboard,
    setDataInDailyErrorParametersDashboard,
  ] = useState([]);
  const [
    dataInWeeklyErrorParametersDashboard,
    setDataInWeeklyErrorParametersDashboard,
  ] = useState([]);
  const [
    dataInMonthlyErrorParametersDashboard,
    setDataInMonthlyErrorParametersDashboard,
  ] = useState([]);

  const Error_LogdailyData = dataInDailyErrorParametersDashboard;
  const Error_LogweeklyData = dataInWeeklyErrorParametersDashboard;
  const Error_LogmonthlyData = dataInMonthlyErrorParametersDashboard;

  const uniqueDailyErrorParametersDates = [
    ...new Set(
      Error_LogdailyData.flatMap((item) =>
        item.Result.map((result) => result.Date)
      )
    ),
  ];
  const uniqueWeeklyErrorParametersDates = [
    ...new Set(
      Error_LogweeklyData.flatMap((item) =>
        item.Result.map((result) => result.Week)
      )
    ),
  ];
  const uniqueMonthlyErrorParametersDates = [
    ...new Set(
      Error_LogmonthlyData.flatMap((item) =>
        item.Result.map((result) => result.Date)
      )
    ),
  ];

  console.log(
    "unique weekly error paramters dates:",
    uniqueWeeklyErrorParametersDates
  );

  console.log(
    "Error weekly dashboard data parameters:",
    dataInWeeklyErrorParametersDashboard
  );

  const dateBasedonPeriodDailyOrWeekly = (period) => {
    const dateObject = { startdate: "", enddate: "" };
    if (period === "daily") {
      dateObject.startdate = dateInDailyDasboard.startdate;
      dateObject.enddate = dateInDailyDasboard.enddate;
    } else if (period === "weekly") {
      dateObject.startdate = dateInWeeklyDasboard.startdate;
      dateObject.enddate = dateInWeeklyDasboard.enddate;
    } else {
      dateObject.startdate = dateInMonthlyDasboard.startdate;
      dateObject.enddate = dateInMonthlyDasboard.enddate;
    }

    return dateObject;
  };

  const dateBasedonPeriodDailyWeeklyMonthlyAgent = (period) => {
    const dateObject = { startdate: "", enddate: "" };
    if (period === "user_daily") {
      dateObject.startdate = dateInDailyAgentDasboard.startdate;
      dateObject.enddate = dateInDailyAgentDasboard.enddate;
    } else if (period === "user_weekly") {
      dateObject.startdate = dateInWeeklyAgentDasboard.startdate;
      dateObject.enddate = dateInWeeklyAgentDasboard.enddate;
    } else {
      dateObject.startdate = dateInMonthlyAgentDasboard.startdate;
      dateObject.enddate = dateInMonthlyAgentDasboard.enddate;
    }

    return dateObject;
  };

  const dateBasedonPeriodDailyWeeklyMonthlyError = (period) => {
    const dateObject = { startdate: "", enddate: "" };
    if (period === "error_daily") {
      dateObject.startdate = dateInErrorDailyDashboard.startdate;
      dateObject.enddate = dateInErrorDailyDashboard.enddate;
    } else if (period === "error_weekly") {
      dateObject.startdate = dateInErrorWeeklyDashboard.startdate;
      dateObject.enddate = dateInErrorWeeklyDashboard.enddate;
    } else {
      dateObject.startdate = dateInErrorMonthlyDashboard.startdate;
      dateObject.enddate = dateInErrorMonthlyDashboard.enddate;
    }

    return dateObject;
  };

  const handleDailyandWeeklySearchButton = async (period) => {
    try {
      const { startdate, enddate } = dateBasedonPeriodDailyOrWeekly(period);
      if (!startdate || !enddate) {
        throw new Error("Please Select both start date and end date");
      }

      if (new Date(startdate) > new Date(enddate)) {
        throw new Error("Start date must be before End date");
      }
      const data = await getDataForDashboard(startdate, enddate, period);
      // console.log(data);

      console.log("data from handleDailyandWeeklySearchButton", data);
      if (data.length === 0) {
        throw new Error(`There is no data between Start Date and End Date`);
      }

      toast.success("Data has arrived successfully", { autoClose: 1800 });
    } catch (error) {
      console.log("Error:", error.message);
      //window.alert(`Error: ${error.message}`);
      toast.error(error.message);

      // throw error;
    }
  };

  console.log(
    "start date in daily error weekly dashboard:",
    dateInErrorWeeklyDashboard.startdate
  );
  console.log(
    "end date in daily error weekly dashboard:",
    dateInErrorWeeklyDashboard.enddate
  );

  //   async function getDataForDailyDashboard(startdate,enddate,period='daily')
  //    {
  //         console.log('Sending for Data for Daily Dashboard');
  //         const req= await ApiCall(
  //         {
  //           start_date:startdate,
  //           enddate:enddate,
  //           period:period
  //         },
  //         "vcare-ui",
  //         "vcareui_getauditgraphdata"
  //         );
  //         const response=req.body;
  //         console.log('Response in DailyDashboard:',response.Quality_Score.daily);
  //        setDataForDailyDashboard(response.Quality_Score.daily);

  //    }

  const handleDailyWeeklyMonthlyAgentSearchButton = async (period) => {
    try {
      const { startdate, enddate } =
        dateBasedonPeriodDailyWeeklyMonthlyAgent(period);

      console.log(
        "start date and end date in handleDailyWeeklyMonthlyAgentSearchButton",
        startdate,
        enddate
      );
      if (!startdate || !enddate) {
        throw new Error("Please Select both start date and end date");
      }

      if (new Date(startdate) > new Date(enddate)) {
        throw new Error("Start date must be before End date");
      }
      const data = await getDataforAgentDashboard(startdate, enddate, period);
      // console.log(data);

      //    console.log("data from handleDailyandWeeklySearchButton",data)
      if (data.length === 0) {
        throw new Error(`There is no data between Start Date and End Date`);
      }
      // const data=await getDataforAgentDashboard(startdate,enddate,period)

      if (period === "user_daily")
        recentValidDateAgent[0] = { startdate, enddate };
      else if (period === "user_weekly")
        recentValidDateAgent[1] = { startdate, enddate };
      else recentValidDateAgent[2] = { startdate, enddate };

      console.log("Recent valid Date agent-------", recentValidDateAgent);
      toast.success("Data has arrived successfully", { autoClose: 1800 });
    } catch (error) {
      //console.log(typeof error.message);
      if (period === "user_daily")
        setDateInDailyAgentDashborad({ ...recentValidDateAgent[0] });
      else if (period === "user_weekly")
        setDateInWeeklyAgentDashborad({ ...recentValidDateAgent[1] });
      else setDateInMonthlyAgentDashborad({ ...recentValidDateAgent[2] });
      toast.error(error.message);
      // throw error;
    }
  };

  const handleDailyWeeklyMonthlyErrorSearchButton = async (period) => {
    try {
      const { startdate, enddate } =
        dateBasedonPeriodDailyWeeklyMonthlyError(period);

      console.log(
        "start date and end date in handleDailyWeeklyMonthlyErrorSearchButton",
        startdate,
        enddate
      );
      if (!startdate || !enddate) {
        throw new Error("Please Select both start date and end date");
      }

      if (new Date(startdate) > new Date(enddate)) {
        throw new Error("Start date must be before End date");
      }
      const data = await getDataforErrorDashboard(startdate, enddate, period);
      // console.log(data);
      console.log("--------------inside error dashboard-----------");
      console.log("data from handleDailyandWeeklySearchButton", data);
      if (data.length === 0) {
        throw new Error(`There is no data between Start Date and End Date`);
      }

      if (period === "error_daily")
        recentValidDateError[0] = { startdate, enddate };
      else if (period === "error_weekly")
        recentValidDateError[1] = { startdate, enddate };
      else recentValidDateError[2] = { startdate, enddate };

      console.log("Recent valid Date error-------", recentValidDateError);
      toast.success("Data has arrived successfully", { autoClose: 1800 });
    } catch (error) {
      //console.log(typeof error.message);
      if (period === "error_daily")
        setDateInErrorDailyDashboard({ ...recentValidDateError[0] });
      else if (period === "error_weekly")
        setDateInErrorWeeklyDashborad({ ...recentValidDateError[1] });
      else setDateInErrorMonthlyDashborad({ ...recentValidDateError[2] });
      toast.error(error.message);
      // throw error;
    }
  };

  const getDataforAgentDashboard = async (startdate, enddate, period) => {
    try {
      // if(!startdate||!enddate)
      // {
      //     throw new Error('Please Select both start date and end date');
      // }
      // if(new Date(startdate)>new Date(enddate))
      // {
      //     throw new Error('Start date must be before End date');
      // }

      console.log("Inside getValidatedTask API call ");

      const api = new Api_Call();
      const ret = await api.getData(
        `AUDIT/STATS?start_date=${startdate}&end_date=${enddate}&period=${period}`
      );
      // const ret = await ApiCall(
      //     {
      //      start_date: startdate,
      //         end_date: enddate,
      //         period: period
      //     },
      //     "vcare-ui",
      //     "vcareui_getauditgraphdata"
      // );
      const response = ret.body;
      console.log("Response in AuditAgentDashboard:", response);
      console.log(
        "setting state ===================================================== "
      );
      // console.log(ret.body);
      let data;

      if (period === "user_daily") {
        data = response.Agent_Score.daily;
        if (data.length > 0) setDataForDailyAgentDashboard(data);
      } else if (period === "user_weekly") {
        data = response.Agent_Score.weekly;
        if (data.length > 0) setDataForWeeklyAgentDashboard(data);
      } else {
        data = response.Agent_Score.monthly;
        if (data.length > 0) setDataForMonthlyAgentDashboard(data);
      }
      console.log("data from getDataForAgentDashboard:", data);
      return data;
      //  if(data.length===0)
      //  {
      //     throw new Error(`There is no data between ${startdate} and ${enddate}`)
      //  }

      //    period==='daily'?setDataForDailyDashboard(response.Quality_Score.daily):setDataForWeeklyDashboard(response.Quality_Score.weekly);
    } catch (error) {
      console.error("Error Fetching:", error.message);
      throw error;
    }
  };

  async function getDataForDashboard(startdate, enddate, period) {
    try {
      // if(!startdate||!enddate)
      // {
      //     throw new Error('Please Select both start date and end date');
      // }
      // if(new Date(startdate)>new Date(enddate))
      // {
      //     throw new Error('Start date must be before End date');
      // }

      console.log("Inside getValidatedTask API call ");
      const ret = await ApiCall(
        {
          start_date: startdate,
          end_date: enddate,
          period: period,
        },
        "vcare-ui",
        "vcareui_getauditgraphdata"
      );
      const response = ret.body;
      console.log("Response in AuditDashboard:", response);
      console.log(
        "setting state ===================================================== "
      );
      // console.log(ret.body);
      let data;

      if (period === "daily") {
        data = response.Quality_Score.daily;
        setDataForDailyDashboard(data);
      } else if (period === "weekly") {
        data = response.Quality_Score.weekly;
        setDataForWeeklyDashboard(data);
      } else {
        data = response.Quality_Score.monthly;
        setDataForMonthlyDashboard(data);
      }
      //  console.log("data from getDataForDashboard:",data);
      return data;
      //  if(data.length===0)
      //  {
      //     throw new Error(`There is no data between ${startdate} and ${enddate}`)
      //  }

      //    period==='daily'?setDataForDailyDashboard(response.Quality_Score.daily):setDataForWeeklyDashboard(response.Quality_Score.weekly);
    } catch (error) {
      console.error("Error Fetching:", error.message);
      throw error;
    }
  }

  // async function getDataForDashboard(startdate, enddate, period) {
  //     console.log('Inside getValidatedTask API call ');
  //     const ret = await ApiCall(
  //         {

  //             start_date: startdate,
  //             end_date: enddate,
  //             period: period
  //         },
  //         "vcare-ui",
  //         "vcareui_getauditgraphdata"
  //     );
  //     const response = ret.body;
  //     console.log('Response in AuditDashboard:',response);
  //     console.log('setting state ===================================================== ');
  //     console.log(ret.body);

  //    period==='daily'?response.Quality_Score.daily.length===0 && dateInDailyDasboard.startdate && dateInDailyDasboard.enddate?alert(`There is no data present between ${dateInDailyDasboard.startdate} and ${dateInDailyDasboard.enddate}`):setDataForDailyDashboard(response.Quality_Score.daily):setDataForWeeklyDashboard(response.Quality_Score.weekly);
  // }

  async function getDataforErrorDashboard(startdate, enddate, period) {
    try {
      // if(!startdate||!enddate)
      // {
      //     throw new Error('Please Select both start date and end date');
      // }
      // if(new Date(startdate)>new Date(enddate))
      // {
      //     throw new Error('Start date must be before End date');
      // }

      console.log("Inside getValidatedTask API call ");
      const ret = await ApiCall(
        {
          start_date: startdate,
          end_date: enddate,
          period: period,
        },
        "vcare-ui",
        "vcareui_getauditgraphdata"
      );
      const response = ret.body;
      console.log("Response in AuditErrorDashboard:", response);
      console.log(
        "setting state ===================================================== "
      );
      // console.log(ret.body);
      let data;

      if (period === "error_daily") {
        data = response.Error_Log;
        setDataInDailyErrorDashboard(data.daily_trend);
        setDataInDailyErrorParametersDashboard(data.daily_count);
      } else if (period === "error_weekly") {
        data = response.Error_Log;
        setDataInWeeklyErrorDashboard(data.weekly_trend);
        console.log(data.weekly_count);
        setDataInWeeklyErrorParametersDashboard(data.weekly_count);
      } else {
        data = response.Error_Log;
        setDataInMonthlyErrorDashboard(data.monthly_trend);
        setDataInMonthlyErrorParametersDashboard(data.monthly_count);
      }
      //  console.log("data from getDataForDashboard:",data);
      return data;
      //  if(data.length===0)
      //  {
      //     throw new Error(`There is no data between ${startdate} and ${enddate}`)
      //  }

      //    period==='daily'?setDataForDailyDashboard(response.Quality_Score.daily):setDataForWeeklyDashboard(response.Quality_Score.weekly);
    } catch (error) {
      console.error("Error Fetching:", error.message);
      throw error;
    }
  }

  const handleSubCategoryClick = (category) => {
    setdailyDataname(dailyData);
    setissec0Visible(false);
    setissec1Visible(false);
    setissec2Visible(false);
    setissec3Visible(false);
    setissec4Visible(false);
    setissec5Visible(false);
    setissec6Visible(false);
    setissec7Visible(false);
    setissec8Visible(false);

    setissec11Visible(false);
    setissec10Visible(false);
    setissec12Visible(false);
    if (category === 1) {
      setissec1Visible(true);
      setdailyDataname(weeklyData);
    }
    if (category === 2) {
      setissec2Visible(true);
    }
    if (category === 3) {
      setissec3Visible(true);
    }
    if (category === 4) {
      setissec6Visible(true);
    }
    if (category === 5) {
      setissec7Visible(true);
    }
    if (category === 6) {
      setissec8Visible(true);
    }
    if (category === 7) {
      setissec9Visible(true);
    }
    if (category === 10) {
      setissec10Visible(true);
    }

    if (category === 11) {
      setissec11Visible(true);
    }
    if (category === 12) {
      setissec12Visible(true);
    }
    setActivesubCategory(category);

    console.log(category);
    return;
  };

  const handleCategoryClick = (category) => {
    setissec0Visible(false);
    setissec1Visible(false);
    setissec2Visible(false);
    setissec3Visible(false);
    setissec4Visible(false);
    setissec5Visible(false);
    setissec6Visible(false);
    setissec7Visible(false);
    setissec8Visible(false);
    setissec9Visible(false);
    setissec11Visible(false);
    setissec12Visible(false);
    setissec13Visible(false);
    // if(category===4)
    // {
    //     setissec4Visible(true);
    // }

    if (category === 1) {
      setissec0Visible(true);
    }
    if (category === 2) {
      setissec4Visible(true);
    }
    if (category === 3) {
      setissec3Visible(true);

      //setissec5Visible(true)
      //setissec10Visible(true);
    }
    if (category === 7) {
      setissec9Visible(true);
    }
    if (category === 13) {
      setissec13Visible(true);
    }
    setActiveCategory(category);
    console.log(category);
  };

  // const uniqueDates = Array.from(
  //     new Set(Error_LogdailyData.map(item => item.Result.Date))
  // );
  return (
    <>
      <div className="pageBodydash">
        <button className="buttonToolbar" onClick={toggleTaskbar}>
          {isLeftTabVisible ? "<<" : ">>"}
        </button>
        <div className="fullbardash">
          {/* <div className={`${isLeftTabVisible?'fullbardash':''}`}> */}
          {/* <button className='buttonToolbar' onClick={toggleTaskbar}>  &lt;&lt; </button> */}
          {/* <div className={"leftbardash"}> */}
          {isLeftTabVisible && (
            <div
              className={`${isLeftTabVisible ? "leftbardash" : ""} taskbar ${
                isHidden ? "hidden" : ""
              }`}
            >
              {/* <div className={`taskbar ${isHidden ? 'hidden' : ''}`}> */}

              <div
                className={`accordionItemdash ${
                  activeCategory === 1 ? "active" : ""
                }`}
                onClick={() => handleCategoryClick(1)}
              >
                <div className="mnuBtn accordionHeaddash" id="btn1">
                  Overall Clinical Quality Dashboard
                </div>
                {/* <div id="detailsSub1" className="slideup accordionBody"> */}
                {/* <div>
                                <ul>
                                    <li>
                                        <div id="subBtn1" className={`subMnuBtn-2 ${activeSubCategory === 1 ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); handleSubCategoryClick(1) }}> Daily Quality Trend </div>
                                    </li>
                                    <li>
                                        <div className={`subMnuBtn-2 ${activeSubCategory === 1 ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); handleSubCategoryClick(2) }} id="subBtn2"> Weekly Quality Trend </div>
                                    </li>
                                    <li>
                                        <div className={`subMnuBtn-2 ${activeSubCategory === 1 ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); handleSubCategoryClick(3) }} id="subBtn3"> Monthly Quality Trend </div>
                                    </li>
                                </ul>
                            </div> */}
                {/* </div> */}
              </div>

              <div
                className={`accordionItemdash ${
                  activeCategory === 3 ? "active" : ""
                }`}
                onClick={() => handleCategoryClick(3)}
              >
                <div className="mnuBtn accordionHeaddash" id="btn3">
                  CMS Compliance Metrics
                </div>
                {/* <div id="detailsSub1" className="slideup accordionBody"> */}
                {/* <div>
                                <ul>
                                    <li>
                                        <div id="subBtn1" className={`subMnuBtn-2 ${activeSubCategory === 1 ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); handleSubCategoryClick(1) }}> Daily Quality Trend </div>
                                    </li>
                                    <li>
                                        <div className={`subMnuBtn-2 ${activeSubCategory === 1 ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); handleSubCategoryClick(2) }} id="subBtn2"> Weekly Quality Trend </div>
                                    </li>
                                    <li>
                                        <div className={`subMnuBtn-2 ${activeSubCategory === 1 ? 'active' : ''}`} onClick={(e) => { e.stopPropagation(); handleSubCategoryClick(3) }} id="subBtn3"> Monthly Quality Trend </div>
                                    </li>
                                </ul>
                            </div> */}
                {/* </div> */}
              </div>
              <div
                className={`accordionItemdash ${
                  activeCategory === 13 ? "active" : ""
                }`}
                onClick={() => handleCategoryClick(13)}
              >
                <div className="mnuBtn accordionHeaddash" id="btn13">
                  {" "}
                  NCQA and URAC Compliance Metrics{" "}
                </div>
                {/* <div id="detailsSub3" className="slideup accordionBody">
                            <div>
                                <ul>
                                    <li>
                                        <div className="subMnuBtn-2"> Weekly Quality Score </div>
                                    </li>
                                    <li>
                                        <div className="subMnuBtn-2"> Monthly Quality Score </div>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
              </div>
              <div
                className={`accordionItemdash ${
                  activeCategory === 2 ? "active" : ""
                }`}
                onClick={() => handleCategoryClick(2)}
              >
                <div className="mnuBtn accordionHeaddash" id="btn2">
                  {" "}
                  Agent Scores{" "}
                </div>
                <div id="detailsSub2" className="slideup accordionBody">
                  <div>
                    <ul>
                      <li>
                        <div
                          className="subMnuBtn-2"
                          id="subBtn4"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSubCategoryClick(4);
                          }}
                        >
                          {" "}
                          Daily Quality Score{" "}
                        </div>
                      </li>
                      <li>
                        <div
                          className="subMnuBtn-2"
                          id="subBtn5"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSubCategoryClick(5);
                          }}
                        >
                          {" "}
                          Weekly Quality Score{" "}
                        </div>
                      </li>
                      <li>
                        <div
                          className="subMnuBtn-2"
                          id="subBtn6"
                          onClick={(e) => {
                            e.stopPropagation();
                            handleSubCategoryClick(6);
                          }}
                        >
                          {" "}
                          Monthly Quality Score{" "}
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* <div className={`accordionItemdash ${activeCategory === 3 ? 'active' : ''}`} onClick={() => handleCategoryClick(3)}>
                        <div className="mnuBtn accordionHeaddash" id="btn3"> Error Log Dashboard </div>
                        <div id="detailsSub3" className="slideup accordionBody">
                            <div>
                                <ul>
                                    <li>
                                    <div className="subMnuBtn-2" onClick={(e) => { e.stopPropagation(); handleSubCategoryClick(10) }}> Daily Quality Score </div>
                                    </li>
                                    <li>
                                        <div className="subMnuBtn-2" onClick={(e) => { e.stopPropagation(); handleSubCategoryClick(11) }}> Weekly Quality Score </div>
                                    </li>
                                    <li>
                                        <div className="subMnuBtn-2" onClick={(e) => { e.stopPropagation(); handleSubCategoryClick(12) }}> Monthly Quality Score </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div> */}

              <div
                className={`accordionItemdash ${
                  activeCategory === 7 ? "active" : ""
                }`}
                onClick={() => handleCategoryClick(7)}
              >
                <div className="mnuBtn accordionHeaddash" id="btn3">
                  {" "}
                  Quality Level Data{" "}
                </div>
                {/* <div className="mnuBtn accordionHeaddash" id="btn3"> QA Dashboard </div> */}
                {/* <div id="detailsSub3" className="slideup accordionBody">
                            <div>
                                <ul>
                                    <li>
                                        <div className="subMnuBtn-2"> Weekly Quality Score </div>
                                    </li>
                                    <li>
                                        <div className="subMnuBtn-2"> Monthly Quality Score </div>
                                    </li>
                                </ul>
                            </div>
                        </div> */}
              </div>

              {/* </div> */}
            </div>
          )}
          <div
            className={`${isLeftTabVisible ? "rightbardash" : ""} ${
              !isLeftTabVisible ? "rightDashMoveLeftandUp" : ""
            } `}
          >
            {/* <div className="rightbardash"> */}
            {isLeftTabVisible && (
              <div className="innerPage-head">
                <div>
                  {issec0Visible && (
                    <h1 className="contentTitle regularSize">
                      Overall Clinical Quality Dashboard
                    </h1>
                  )}
                  {issec3Visible && (
                    <h1 className="contentTitle regularSize">
                      CMS Compliance Metrics
                    </h1>
                  )}
                  {issec13Visible && (
                    <h1 className="contentTitle regularSize">
                      {" "}
                      NCQA and URAC Compliance Metrics{" "}
                    </h1>
                  )}
                  {issec4Visible && (
                    <h1 className="contentTitle regularSize">Agent Scores</h1>
                  )}
                  {issec9Visible && (
                    <h1 className="contentTitle regularSize">
                      {" "}
                      Quality Level Data
                    </h1>
                  )}
                </div>
              </div>
            )}
            <div className={`${isLeftTabVisible ? "innerPage-body" : ""}`}>
              {
                issec0Visible && (
                  <iframe
                    title="DIGITAL UM - REVIEW DASHBOARD"
                    width="100%"
                    height="675"
                    src="https://app.powerbi.com/reportEmbed?reportId=55a8d58e-0da9-4654-9380-92e16ba20046&autoAuth=true&ctid=dafe49bc-5ac3-4310-97b4-3e44a28cbf18"
                    frameborder="0"
                    allowFullScreen="true"
                  ></iframe>
                )
                // issec0Visible &&
                //     <div id="report1-overview" >
                //         <div className="chartWrap">

                //             {/* <Line data={data} options={options}></Line> */}
                //             <LineChart data={dataForDailyDashboard} label="Daily Score vs. 95% Goal" className="charts-50" />
                //             <LineChart data={dataForWeeklyDashboard} label="Weekly Score vs. 95% Goal" className="charts-50" />
                //             <LineChart data={dataForMonthlyDashboard} label="Monthly Score vs. 95% Goal" className="charts-100" />
                //         </div>
                //     </div>)
              }
              {
                // issec1Visible && (
                //     <div id="report1" >
                //         <div className='field-container'>
                //             <label class="">Start Date:</label>
                //             <div className='field-text'>  <input className='textbox' type='date' value={dateInDailyDasboard.startdate} min="2014-01-01" onChange={(e)=>{setDateInDailyDashborad((prevValue)=>{return {...prevValue, startdate:e.target.value}})}}></input></div>
                //             <label class=""> End Date:</label>
                //             <div className='field-text'>  <input className='textbox' type='date' value={dateInDailyDasboard.enddate} min="2014-01-01" onChange={(e)=>{setDateInDailyDashborad((prevValue)=>{return {...prevValue, enddate:e.target.value}})}} ></input></div>
                //             <button className='btn btn--outline btn--medium' onClick={()=>{handleDailyandWeeklySearchButton('daily')}}>Search</button>
                //         </div>
                //         <LineChart data={dataForDailyDashboard} label="Daily Score vs. 95% Goal" className="charts-100" />
                //     </div>)
              }
              {/* {issec2Visible && (
                            <div id="report2" >
                                <div className='field-container'>
                                    <label class="">Start Date:</label>
                                    <div className='field-text'>  <input className='textbox' type='date' value={dateInWeeklyDasboard.startdate} min="2014-01-01" onChange={(e)=>{setDateInWeeklyDashborad((prevValue)=>{return {...prevValue, startdate:e.target.value}})}}></input></div>
                                    <label class=""> End Date:</label>
                                    <div className='field-text'>  <input className='textbox' type='date' value={dateInWeeklyDasboard.enddate} min="2014-01-01" onChange={(e)=>{setDateInWeeklyDashborad((prevValue)=>{return {...prevValue, enddate:e.target.value}})}}></input></div>
                                    <button className='btn btn--outline btn--medium' onClick={()=>{handleDailyandWeeklySearchButton('weekly')}}>Search</button>
                                </div>
                                <LineChart data={dataForWeeklyDashboard} label="Weekly Score vs. 95% Goal" className="charts-100" />

                            </div>
                        )} */}
              {
                issec3Visible && (
                  <iframe
                    title="DIGITAL UM - REVIEW DASHBOARD"
                    width="100%"
                    height="675"
                    src="https://app.powerbi.com/reportEmbed?reportId=55a8d58e-0da9-4654-9380-92e16ba20046&autoAuth=true&ctid=dafe49bc-5ac3-4310-97b4-3e44a28cbf18"
                    frameborder="0"
                    allowFullScreen="true"
                  ></iframe>
                )
                //  (
                //     <div id="report3">
                //         <div className='field-container'>
                //             <label class="">Start Date:</label>
                //             <div className='field-text'>  <input className='textbox' type='date' value={dateInMonthlyDasboard.startdate} min="2014-01-01" onChange={(e)=>{setDateInMonthlyDashborad((prevValue)=>{return {...prevValue, startdate:e.target.value}})}}></input></div>
                //             <label class=""> End Date:</label>
                //             <div className='field-text'>  <input className='textbox' type='date' value={dateInMonthlyDasboard.enddate} min="2014-01-01" onChange={(e)=>{setDateInMonthlyDashborad((prevValue)=>{return {...prevValue, enddate:e.target.value}})}}></input></div>
                //             <button className='btn btn--outline btn--medium' onClick={()=>{handleDailyandWeeklySearchButton('monthly')}}>Search</button>
                //         </div>
                //         {/* <div className="dateWrap">
                //         <label>Start Date:</label>
                //         <input type="text" />
                //         <label>End Date:</label>
                //         <input type="text" />
                //     </div> */}
                //         <LineChart data={dataForMonthlyDashboard} label="Monthly Score vs. 95% Goal" className="charts-100" />

                //     </div>
                // )
              }

              {issec13Visible && (
                <iframe
                  title="DIGITAL UM - REVIEW DASHBOARD"
                  width="100%"
                  height="675"
                  src="https://app.powerbi.com/reportEmbed?reportId=55a8d58e-0da9-4654-9380-92e16ba20046&autoAuth=true&ctid=dafe49bc-5ac3-4310-97b4-3e44a28cbf18"
                  frameborder="0"
                  allowFullScreen="true"
                ></iframe>
              )}
              {issec4Visible && (
                <div id="report2-overview">
                  <div className="chartWrap">
                    <div id="chart4" className="charts-100">
                      <div className="subTitle">
                        <h3>Daily Quality Score</h3>
                      </div>
                      <div id="tableData">
                        <table className="brandTable">
                          <thead>
                            <tr>
                              <th style={{ width: "300px" }}>AGENT NAME</th>
                              {Agent_ScoreuniqueDatesdaily.map((Date) => (
                                <th key={Date}>{Date}</th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {Agent_ScoredailyData.map((item) => (
                              <tr>
                                <td>{item.USER_NAME}</td>

                                {Agent_ScoreuniqueDatesdaily.map((Date) => {
                                  const result = item.Scores.find(
                                    (result) => result.X === Date
                                  );
                                  return (
                                    <td
                                      style={{
                                        color: "white",
                                        backgroundColor: result
                                          ? result.COLOUR
                                          : colorForAgentIfdataNotFound,
                                      }}
                                    >
                                      {result ? result.Y + "%" : ""}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div id="chart5" className="charts-100">
                      <div className="subTitle">
                        <h3>Weekly Quality Score</h3>
                      </div>
                      <div id="tableData">
                        <table className="brandTable">
                          <thead>
                            <tr>
                              <th style={{ width: "300px" }}>AGENT NAME</th>
                              {Agent_ScoreuniqueDatesweekly.map((Date) => (
                                <th key={Date}>{Date}</th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {Agent_ScoreweeklyData.map((item) => (
                              <tr>
                                <td>{item.USER_NAME}</td>

                                {Agent_ScoreuniqueDatesweekly.map((Date) => {
                                  const result = item.Scores.find(
                                    (result) => result.X === Date
                                  );
                                  return (
                                    <td
                                      style={{
                                        color: "white",
                                        backgroundColor: result
                                          ? result.COLOUR
                                          : colorForAgentIfdataNotFound,
                                      }}
                                    >
                                      {result ? result.Y + "%" : ""}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                    <div id="chart6" className="charts-100">
                      <div className="subTitle">
                        <h3>Monthly Quality Score</h3>
                      </div>
                      <div id="tableData" class="brandTableContainer">
                        <table
                          className="brandTable"
                          style={stylesForAgentTable}
                        >
                          <thead>
                            <tr>
                              <th
                                style={{
                                  width: "300px",
                                  ...stylesForAgentTable,
                                }}
                              >
                                AGENT NAME
                              </th>
                              {Agent_ScoreuniqueDatesmonthly.map((Date) => (
                                <th
                                  style={{
                                    width: "300px",
                                    ...stylesForAgentTable,
                                  }}
                                  key={Date}
                                >
                                  {Date}
                                </th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {Agent_ScoremonthlyData.map((item) => (
                              <tr>
                                <td style={stylesForAgentTable}>
                                  {item.USER_NAME}
                                </td>

                                {Agent_ScoreuniqueDatesmonthly.map((Date) => {
                                  const result = item.Scores.find(
                                    (result) => result.X === Date
                                  );
                                  console.log(
                                    `result of ${item.USER_NAME} is ${result}`
                                  );
                                  return (
                                    <td
                                      style={{
                                        color: "white",
                                        backgroundColor: result
                                          ? result.COLOUR
                                          : colorForAgentIfdataNotFound,
                                        ...stylesForAgentTable,
                                      }}
                                    >
                                      {result ? result.Y + "%" : ""}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}

              {issec6Visible && (
                <div id="report2-overview">
                  <div className="chartWrap">
                    <div className="field-container">
                      <label class="">Start Date:</label>
                      <div className="field-text">
                        {" "}
                        <input
                          className="textbox"
                          type="date"
                          value={dateInDailyAgentDasboard.startdate}
                          min="2014-01-01"
                          onChange={(e) => {
                            setDateInDailyAgentDashborad((prevValue) => {
                              return {
                                ...prevValue,
                                startdate: e.target.value,
                              };
                            });
                          }}
                        ></input>
                      </div>
                      <label class=""> End Date:</label>
                      <div className="field-text">
                        {" "}
                        <input
                          className="textbox"
                          type="date"
                          value={dateInDailyAgentDasboard.enddate}
                          min="2014-01-01"
                          onChange={(e) => {
                            setDateInDailyAgentDashborad((prevValue) => {
                              return { ...prevValue, enddate: e.target.value };
                            });
                          }}
                        ></input>
                      </div>
                      <button
                        className="btn btn--outline btn--medium"
                        onClick={() => {
                          handleDailyWeeklyMonthlyAgentSearchButton(
                            "user_daily"
                          );
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div id="chart4" className="charts-100">
                      <div className="subTitle">
                        <h3>Daily Quality Score</h3>
                      </div>

                      <div id="tableData">
                        <table className="brandTable">
                          <thead>
                            <tr>
                              <th style={{ width: "300px" }}>AGENT NAME</th>
                              {Agent_ScoreuniqueDatesdaily.map((Date) => (
                                <th key={Date}>{Date}</th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {Agent_ScoredailyData.map((item) => (
                              <tr>
                                <td>{item.USER_NAME}</td>

                                {Agent_ScoreuniqueDatesdaily.map((Date) => {
                                  const result = item.Scores.find(
                                    (result) => result.X === Date
                                  );
                                  return (
                                    <td
                                      style={{
                                        color: "white",
                                        backgroundColor: result
                                          ? result.COLOUR
                                          : colorForAgentIfdataNotFound,
                                      }}
                                    >
                                      {result ? result.Y + "%" : ""}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {issec7Visible && (
                <div id="report2-overview">
                  <div className="chartWrap">
                    <div className="field-container">
                      <label class="">Start Date:</label>
                      <div className="field-text">
                        {" "}
                        <input
                          className="textbox"
                          type="date"
                          value={dateInWeeklyAgentDasboard.startdate}
                          min="2014-01-01"
                          onChange={(e) => {
                            setDateInWeeklyAgentDashborad((prevValue) => {
                              return {
                                ...prevValue,
                                startdate: e.target.value,
                              };
                            });
                          }}
                        ></input>
                      </div>
                      <label class=""> End Date:</label>
                      <div className="field-text">
                        {" "}
                        <input
                          className="textbox"
                          type="date"
                          value={dateInWeeklyAgentDasboard.enddate}
                          min="2014-01-01"
                          onChange={(e) => {
                            setDateInWeeklyAgentDashborad((prevValue) => {
                              return { ...prevValue, enddate: e.target.value };
                            });
                          }}
                        ></input>
                      </div>
                      <button
                        className="btn btn--outline btn--medium"
                        onClick={() => {
                          handleDailyWeeklyMonthlyAgentSearchButton(
                            "user_weekly"
                          );
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div id="chart5" className="charts-100">
                      <div className="subTitle">
                        <h3>Weekly Quality Score</h3>
                      </div>
                      <div id="tableData">
                        <table className="brandTable">
                          <thead>
                            <tr>
                              <th style={{ width: "300px" }}>AGENT NAME</th>
                              {Agent_ScoreuniqueDatesweekly.map((Date) => (
                                <th key={Date}>{Date}</th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {Agent_ScoreweeklyData.map((item) => (
                              <tr>
                                <td>{item.USER_NAME}</td>

                                {Agent_ScoreuniqueDatesweekly.map((Date) => {
                                  const result = item.Scores.find(
                                    (result) => result.X === Date
                                  );
                                  return (
                                    <td
                                      style={{
                                        color: "white",
                                        backgroundColor: result
                                          ? result.COLOUR
                                          : colorForAgentIfdataNotFound,
                                      }}
                                    >
                                      {result ? result.Y + "%" : ""}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {issec8Visible && (
                <div id="report2-overview">
                  <div className="chartWrap">
                    <div className="field-container">
                      <label class="">Start Date:</label>
                      <div className="field-text">
                        {" "}
                        <input
                          className="textbox"
                          type="date"
                          value={dateInMonthlyAgentDasboard.startdate}
                          min="2014-01-01"
                          onChange={(e) => {
                            setDateInMonthlyAgentDashborad((prevValue) => {
                              return {
                                ...prevValue,
                                startdate: e.target.value,
                              };
                            });
                          }}
                        ></input>
                      </div>
                      <label class=""> End Date:</label>
                      <div className="field-text">
                        {" "}
                        <input
                          className="textbox"
                          type="date"
                          value={dateInMonthlyAgentDasboard.enddate}
                          min="2014-01-01"
                          onChange={(e) => {
                            setDateInMonthlyAgentDashborad((prevValue) => {
                              return { ...prevValue, enddate: e.target.value };
                            });
                          }}
                        ></input>
                      </div>
                      <button
                        className="btn btn--outline btn--medium"
                        onClick={() => {
                          handleDailyWeeklyMonthlyAgentSearchButton(
                            "user_monthly"
                          );
                        }}
                      >
                        Search
                      </button>
                    </div>
                    <div id="chart6" className="charts-100">
                      <div className="subTitle">
                        <h3>Monthly Quality Score</h3>
                      </div>
                      <div id="tableData">
                        <table className="brandTable">
                          <thead
                            id="stylesInthClient"
                            style={stylesForAgentTable}
                          >
                            <tr>
                              <th
                                style={{
                                  width: "100px",
                                  ...stylesForAgentTable,
                                }}
                              >
                                AGENT NAME
                              </th>
                              {Agent_ScoreuniqueDatesmonthly.map((Date) => (
                                <th style={stylesForAgentTable} key={Date}>
                                  {Date}
                                </th>
                              ))}
                            </tr>
                          </thead>

                          <tbody>
                            {Agent_ScoremonthlyData.map((item) => (
                              <tr>
                                <td style={stylesForAgentTable}>
                                  {item.USER_NAME}
                                </td>

                                {Agent_ScoreuniqueDatesmonthly.map((Date) => {
                                  const result = item.Scores.find(
                                    (result) => result.X === Date
                                  );
                                  return (
                                    <td
                                      style={{
                                        backgroundColor: result
                                          ? result.COLOUR
                                          : colorForAgentIfdataNotFound,
                                        ...stylesForAgentTable,
                                      }}
                                    >
                                      {result ? result.Y + "%" : ""}
                                    </td>
                                  );
                                })}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              {/* <!--Error Log Dashboard--> */}
              {
                // issec10Visible && (
                //     <div id="report3-overview" >
                //         <div className='field-container'>
                //                 <label class="">Start Date:</label>
                //                 <div className='field-text'>  <input className='textbox' type='date' value={dateInErrorDailyDashboard.startdate} min="2014-01-01" onChange={(e)=>{setDateInErrorDailyDashboard((prevValue)=>{return {...prevValue, startdate:e.target.value}})}} ></input></div>
                //                 <label class=""> End Date:</label>
                //                 <div className='field-text'>  <input className='textbox' type='date' value={dateInErrorDailyDashboard.enddate} min="2014-01-01" onChange={(e)=>{setDateInErrorDailyDashboard((prevValue)=>{return {...prevValue, enddate:e.target.value}})}} ></input></div>
                //                 <button className='btn btn--outline btn--medium' onClick={()=>{handleDailyWeeklyMonthlyErrorSearchButton('error_daily')}}>Search</button>
                //             </div>
                //         <BarChart data={dataInDailyErrorDashboard} label="Daily Error Trend" className="charts-100" />
                //         <div id="tableData" class="charts">
                //             <table class="brandTable">
                //                 <thead>
                //                     <tr>
                //                         <th style={{ width: '300px' }}>Parameters</th>
                //                         {uniqueDailyErrorParametersDates.map(Date => (
                //                             <th key={Date}>{Date}</th>
                //                         ))}
                //                     </tr>
                //                 </thead>
                //                 <tbody>
                //                     {Error_LogdailyData.map(item => (
                //                         <tr key={item.QID}>
                //                             <td>{item.Question}</td>
                //                             {uniqueDailyErrorParametersDates.map(Date => {
                //                                 const result = item.Result.find(result => result.Date === Date);
                //                                 return (
                //                                     <td key={Date} style={{ backgroundColor: result ? result.COLOR : 'white' }}>
                //                                         {result ? result.Count : ''}
                //                                     </td>
                //                                 );
                //                             })}
                //                         </tr>
                //                     ))}
                //                 </tbody>
                //             </table>                            </div>
                //     </div>
                // )
              }
              {issec11Visible && (
                <div id="report3-overview">
                  <div className="field-container">
                    <label class="">Start Date:</label>
                    <div className="field-text">
                      {" "}
                      <input
                        className="textbox"
                        type="date"
                        value={dateInErrorWeeklyDashboard.startdate}
                        min="2014-01-01"
                        onChange={(e) => {
                          setDateInErrorWeeklyDashborad((prevValue) => {
                            return { ...prevValue, startdate: e.target.value };
                          });
                        }}
                      ></input>
                    </div>
                    <label class=""> End Date:</label>
                    <div className="field-text">
                      {" "}
                      <input
                        className="textbox"
                        type="date"
                        value={dateInErrorWeeklyDashboard.enddate}
                        min="2014-01-01"
                        onChange={(e) => {
                          setDateInErrorWeeklyDashborad((prevValue) => {
                            return { ...prevValue, enddate: e.target.value };
                          });
                        }}
                      ></input>
                    </div>
                    <button
                      className="btn btn--outline btn--medium"
                      onClick={() => {
                        handleDailyWeeklyMonthlyErrorSearchButton(
                          "error_weekly"
                        );
                      }}
                    >
                      Search
                    </button>
                  </div>

                  <BarChart
                    data={dataInWeeklyErrorDashboard}
                    label="Weekly Error Trend"
                    className="charts-100"
                  />
                  <div id="tableData" class="charts">
                    <table class="brandTable">
                      <thead>
                        <tr>
                          <th style={{ width: "300px" }}>Parameters</th>
                          {uniqueWeeklyErrorParametersDates.map((Date) => (
                            <th key={Date}>{Date}</th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {Error_LogweeklyData.map((item) => (
                          <tr key={item.QID}>
                            <td>{item.Question}</td>

                            {uniqueWeeklyErrorParametersDates.map((Week) => {
                              const result = item.Result.find(
                                (result) => result.Week === Week
                              );
                              return (
                                <td
                                  key={Week}
                                  style={{
                                    backgroundColor: result
                                      ? result.COLOR
                                      : "white",
                                  }}
                                >
                                  {result ? result.Count : ""}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>{" "}
                  </div>
                </div>
              )}
              {issec12Visible && (
                <div id="report3-overview">
                  <div className="field-container">
                    <label class="">Start Date:</label>
                    <div className="field-text">
                      {" "}
                      <input
                        className="textbox"
                        type="date"
                        value={dateInErrorMonthlyDashboard.startdate}
                        min="2014-01-01"
                        onChange={(e) => {
                          setDateInErrorMonthlyDashborad((prevValue) => {
                            return { ...prevValue, startdate: e.target.value };
                          });
                        }}
                      ></input>
                    </div>
                    <label class=""> End Date:</label>
                    <div className="field-text">
                      {" "}
                      <input
                        className="textbox"
                        type="date"
                        value={dateInErrorMonthlyDashboard.enddate}
                        min="2014-01-01"
                        onChange={(e) => {
                          setDateInErrorMonthlyDashborad((prevValue) => {
                            return { ...prevValue, enddate: e.target.value };
                          });
                        }}
                      ></input>
                    </div>
                    <button
                      className="btn btn--outline btn--medium"
                      onClick={() => {
                        handleDailyWeeklyMonthlyErrorSearchButton(
                          "error_monthly"
                        );
                      }}
                    >
                      Search
                    </button>
                  </div>

                  <BarChart
                    data={dataInMonthlyErrorDashboard}
                    label="Monthly Error Trend"
                    className="charts-100"
                  />
                  <div id="tableData" class="charts">
                    <table class="brandTable">
                      <thead>
                        <tr>
                          <th style={{ width: "300px" }}>Parameters</th>
                          {uniqueMonthlyErrorParametersDates.map((Date) => (
                            <th key={Date}>{Date}</th>
                          ))}
                        </tr>
                      </thead>

                      <tbody>
                        {Error_LogmonthlyData.map((item) => (
                          <tr key={item.QID}>
                            <td>{item.Question}</td>

                            {uniqueMonthlyErrorParametersDates.map((Date) => {
                              const result = item.Result.find(
                                (result) => result.Date === Date
                              );
                              return (
                                <td
                                  key={Date}
                                  style={{
                                    backgroundColor: result
                                      ? result.COLOR
                                      : "white",
                                  }}
                                >
                                  {result ? result.Count : ""}
                                </td>
                              );
                            })}
                          </tr>
                        ))}
                      </tbody>
                    </table>{" "}
                  </div>
                </div>
              )}
              {/* {issec9Visible && (
                            <div id="report4-overview">
                                <div className="chartWrap">
                                    <ChartComponent className="charts-100" data={QA_Total_Volume} label="Percentage of Cases Audited /Total Volume"></ChartComponent>
                                    <ChartComponent className="charts-100" data={QA_Completion_Rate} label="Audit Completion Rate"></ChartComponent>
                                    <ChartComponent className="charts-100" data={QA_Audit_Timing} label="QCA Auditing Time"></ChartComponent> */}
              {/* <div id="chart8" className="charts-100"> </div>
            <div id="chart9" className="charts-100"> </div>
            <div id="chart10" className="charts-100"> </div> */}
              {/* </div>
                            </div>
                        )} */}
              {issec9Visible && (
                <iframe
                  title="DIGITAL UM - REVIEW DASHBOARD"
                  width="100%"
                  height="675"
                  src="https://app.powerbi.com/reportEmbed?reportId=55a8d58e-0da9-4654-9380-92e16ba20046&autoAuth=true&ctid=dafe49bc-5ac3-4310-97b4-3e44a28cbf18"
                  frameborder="0"
                  allowFullScreen="true"
                ></iframe>
              )}
            </div>
          </div>
        </div>
      </div>

      {/* <div>
            <HighchartsReact highcharts={Highcharts} options={chartOptions} />
        </div>
        <div className='chartjsline'>
            <h2>ChartJs line chart</h2>
            <Line data={data} options={options}></Line>
        </div> */}
    </>
  );
}
export default AuditDashboard;
